import type { ReactNode } from "react";

interface SectionHeaderProps {
	eyebrow?: ReactNode;
	title: string;
	subtitle?: string;
	titleSize?: "md" | "lg";
	wrapperClassName?: string;
	titleClassName?: string;
	subtitleClassName?: string;
}

/**
 * Shared "eyebrow? + heading + subtitle" block. Callers own their exact
 * wrapper/subtitle classes (alignment, max-width, spacing differ per
 * section) so every section keeps its original layout pixel-for-pixel.
 */
function SectionHeader(prop: SectionHeaderProps) {
	const {
		eyebrow,
		title,
		subtitle,
		titleSize = "md",
		wrapperClassName,
		titleClassName,
		subtitleClassName,
	} = prop;
	return (
		<div className={wrapperClassName}>
			{eyebrow}
			<h2
				className={
					titleClassName ??
					(titleSize === "lg"
						? "text-4xl font-extrabold tracking-tight sm:text-5xl"
						: "text-3xl font-bold tracking-tight sm:text-4xl")
				}
			>
				{title}
			</h2>
			{subtitle && (
				<p className={subtitleClassName ?? "mt-4 text-lg leading-relaxed text-muted-foreground"}>
					{subtitle}
				</p>
			)}
		</div>
	);
}

export default SectionHeader;
